var exports = {
  "z": "x1cb7f6e3--000dc1--root",
};

module.exports = exports;
